import { render, staticRenderFns } from "./WebPhoneContactOverlay.vue?vue&type=template&id=04abf95a&scoped=true"
import script from "./WebPhoneContactOverlay.vue?vue&type=script&lang=js"
export * from "./WebPhoneContactOverlay.vue?vue&type=script&lang=js"
import style0 from "./WebPhoneContactOverlay.vue?vue&type=style&index=0&id=04abf95a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04abf95a",
  null
  
)

export default component.exports